import { Modal } from "react-bootstrap";
import toast from "react-hot-toast";
import { Button } from "../../../components";
import { CurrencyInput, FormSelect } from "../../../components/forms";
import ThemedModal from "../../../components/utilities/ThemedModal";
import { useCustodianTransactionMatching } from "../hooks/CustodianTransactionMatchingContext";
import useBulkResolve from "../hooks/useBulkResolve";

const BulkResolveModal = ({ show, onHide }) => {

    const { bulkResolveExceptions, bulkResolveResult: { isLoading: isResolving } } = useCustodianTransactionMatching();

    const {
        request,
        updateRequest,
        resetRequest,
        custodianOptions,
        transactionTypeOptions,
        resolutionTypeOptions,
        canSubmit
    } = useBulkResolve();

    const onClose = () => {
        resetRequest();
        onHide();
    };

    const onSubmit = (e) => {
        if (typeof e?.preventDefault === "function") {
            e.preventDefault();
        }

        toast.promise(bulkResolveExceptions(request), {
            loading: "Resolving exceptions...",
            error: (err) => err?.data?.message ?? err?.message ?? "Unable to resolve exceptions",
            success: "Exceptions resolved!"
        }).then(() => {
            onClose();
        });
    };

    return <Modal dialogClassName="min-w-25" show={show} onHide={onClose} centered backdrop="static" size="sm">
        <ThemedModal.Header closeButton>
            <Modal.Title>Resolve Transactions</Modal.Title>
        </ThemedModal.Header>
        <Modal.Body>
            <p>Please select a value for which all transactions with values lower will be resolved using the provided method.</p>
            <div className="row mb-3">
                <div className="col-6">
                    <FormSelect
                        label={"Transaction Type"}
                        options={transactionTypeOptions}
                        onChange={({ value }) => updateRequest("platformTransactionType", value)}
                        defaultValue={request.platformTransactionType}
                        disableAnimations
                    />
                </div>
                <div className="col-6">
                    <FormSelect
                        label={"Custodian"}
                        options={custodianOptions}
                        onChange={({ value }) => updateRequest("custodianCode", value)}
                        defaultValue={request.custodianCode}
                        disableAnimations
                    />
                </div>
            </div>
            <div className="row mb-3">
                <div className="col">
                    <FormSelect
                        label={"Resolution Type"}
                        options={resolutionTypeOptions}
                        onChange={({ value }) => updateRequest("resolutionType", value)}
                        defaultValue={request.resolutionType}
                        disableAnimations
                    />
                </div>
                <div className="col">
                    <CurrencyInput
                        label={"Value"}
                        onChange={(_, { floatValue }) => updateRequest("maxValue", floatValue)}
                        value={request.maxValue}
                        disableAnimations
                    />
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="success" onClick={onSubmit} disabled={isResolving || !canSubmit}>Resolve</Button>
            <Button variant="light" onClick={onClose}>Cancel</Button>
        </Modal.Footer>
    </Modal>

};

export default BulkResolveModal;